<script lang="ts" setup>
import { useWorkspaceEntityStore } from '#layers/runtime/public';

const props = defineProps<{
	id: string;
}>();

const emit = defineEmits<{
	close: [];
}>();

const store = useWorkspaceEntityStore();

const editPageSection = await store.MonospacePageSection.updateForm(props.id);

editPageSection.$onSuccess(() => {
	emit('close');
});
</script>

<template>
	<DDialog :title="$t('page_section.edit.title')">
		<template #body>
			<DForm
				id="page-section-edit-form"
				:state="editPageSection"
				:schema="editPageSection.$schema"
				layout="side-by-side"
				auto-focus-first-input
				@submit="editPageSection.$submit()"
			>
				<DFormField
					name="title"
					:label="$t('page_section.title')"
				>
					<DInput
						v-model="editPageSection.title"
						:placeholder="$t('page_section.title_placeholder')"
					/>
				</DFormField>
			</DForm>
		</template>

		<template #footer>
			<DButton
				:label="$t('common.cancel')"
				color="neutral"
				variant="outline"
				size="sm"
				@click="emit('close')"
			/>

			<DButton
				type="submit"
				form="page-section-edit-form"
				:label="$t('page_section.edit.submit')"
				size="sm"
			/>
		</template>
	</DDialog>
</template>
